(function() {
   'use strict';

   window.TSC = window.TSC || {};

   window.TSC.themeNames = (function() {
      return {
         DAWN: 'dawn',
         DUSK: 'dusk'
      };
   })();
})();
